import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f382fca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f382fca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f382fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f382fca')) {
      api.createRecord('4f382fca', component.options)
    } else {
      api.reload('4f382fca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f382fca&scoped=true", function () {
      api.rerender('4f382fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubi/Header/components/LangSelect/index.vue"
export default component.exports